import React, { useState } from 'react';
import {
  IWorkDaysRules,
  IWorkBreaksRules,
} from 'shared/api/booking/interfaces/work-time-rules.interface';
import { DefaultButton } from 'shared/ui';
import styles from './settings.module.scss';
import { parseDateFromDatetime } from 'shared/lib';

interface IRulesListProps {
  workDays: IWorkDaysRules[];
  workBreaks: IWorkBreaksRules[];
  onDeleteDay: (id: string) => void;
  onDeleteBreak: (id: string) => void;
}

const DAY_NAMES: Record<number, string> = {
  0: 'Вс',
  1: 'Пн',
  2: 'Вт',
  3: 'Ср',
  4: 'Чт',
  5: 'Пт',
  6: 'Сб',
};

function formatDateWithDay(dateStr: string): string {
  const date = new Date(dateStr);
  const dayName = DAY_NAMES[date.getDay()] || '';
  return `${parseDateFromDatetime(dateStr)} ${dayName}`;
}

function formatDayType(rule: IWorkDaysRules): string {
  if (rule.daysRule.countDaysOver > 0) {
    return `Сменный ${rule.daysRule.countDaysRunning}/${rule.daysRule.countDaysOver}`;
  }
  if (rule.startedAt === '00:00' && rule.finishedAt === '00:00') {
    return 'Выходной';
  }
  return `${rule.startedAt} - ${rule.finishedAt}`;
}

function formatBreakTime(rule: IWorkBreaksRules): string {
  return `${rule.timeRule.startedAt} - ${rule.timeRule.finishedAt}`;
}

export const RulesList: React.FC<IRulesListProps> = ({
  workDays,
  workBreaks,
  onDeleteDay,
  onDeleteBreak,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  if (workDays.length === 0 && workBreaks.length === 0) return null;

  return (
    <div className={styles.rules_list}>
      <div
        className={styles.rules_list__header}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className={styles.rules_list__arrow}>{isOpen ? '▲' : '▼'}</span>
        <span className={styles.rules_list__title}>Все правила</span>
      </div>

      {isOpen && (
        <>
          {workDays.length > 0 && (
            <div className={styles.rules_list__section}>
              <div className={styles.rules_list__section_title}>
                Рабочие дни
              </div>
              {workDays.map((rule) => (
                <div key={rule.id} className={styles.rules_list__item}>
                  <div className={styles.rules_list__info}>
                    <span className={styles.rules_list__date}>
                      {formatDateWithDay(rule.dateStart)}
                    </span>
                    <span className={styles.rules_list__type}>
                      {formatDayType(rule)}
                    </span>
                  </div>
                  <DefaultButton
                    buttonText="Удалить"
                    color="red"
                    className={styles.rules_list__delete}
                    onClick={() => onDeleteDay(rule.id)}
                  />
                </div>
              ))}
            </div>
          )}

          {workBreaks.length > 0 && (
            <div className={styles.rules_list__section}>
              <div className={styles.rules_list__section_title}>Перерывы</div>
              {workBreaks.map((rule) => (
                <div key={rule.id} className={styles.rules_list__item}>
                  <div className={styles.rules_list__info}>
                    <span className={styles.rules_list__date}>
                      {formatDateWithDay(rule.dateStart)}
                    </span>
                    <span className={styles.rules_list__name}>
                      {rule.title}
                    </span>
                    <span className={styles.rules_list__type}>
                      {formatBreakTime(rule)}
                    </span>
                  </div>
                  <DefaultButton
                    buttonText="Удалить"
                    color="red"
                    className={styles.rules_list__delete}
                    onClick={() => onDeleteBreak(rule.id)}
                  />
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
};
